/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-undef */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./ns-quiq-chat-button.html";
import { BrowserDetection, events } from "@nuskin/ns-util";

/**
 * Component renders a button that launches a QuiqChat chat window based on provided configuration.
 */
export class NsQuiqChatButton extends PolymerElement {
  static get is() {
    return "ns-quiq-chat-button";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * The visible text on the button.
       */
      buttonDisplayName: {
        type: String,
        value: "Default"
      },
      /**
       * The contact point used by QuiqChat.
       */
      chatType: {
        type: String,
        value: "customer-order-support"
      },
      /**
       * The support number to contact.
       */
      phoneNumber: {
        type: String
      },
      /**
       * Initialized and configured QuiqChat object generated by properties passed into the component and the QuiqChat script.
       */
      _chat: {
        type: Object
      },
      /**
       * Tracks if the connection to QuiqChat is active.
       */
      _quiqChatInitialized: {
        type: Boolean,
        value: false
      },
      /**
       * Tracks if the chat window is visible on the screen.
       */
      _chatVisibility: {
        type: Boolean,
        value: false
      },
      disabled: {
        type: Boolean,
        value: false
      },
      /**
       * This will force the web client on a mobile device
       */
      useWebClientAlways: {
        type: Boolean,
        value: false
      },
      /**
       * Tenant that will be used to initialize quiq chat API
       */
      tenant: {
        type: String,
        value: "nuskin"
      }
    };
  }

  ready() {
    super.ready();
    events.subscribe("quiq-chat-initialized", (chat) => {
      this._quiqChatInitialized = true;
      this._chat = chat;
    });
    events.subscribe("quiq-chat-visibility", () => {});
    events.subscribe("quiqChatClosed", () => {
      this._chatVisibility = false;
    });
    if (BrowserDetection.isMobile() && !this.useWebClientAlways) {
      this.href = "sms:" + this.phoneNumber;
    }
  }

  startChat() {
    if (this._quiqChatInitialized) {
      this._toggleChat();
      return;
    }

    if (typeof Quiq !== "undefined") {
      let newChat = {
        host: `https://${this.tenant}.goquiq.com`,
        contactPoint: this.chatType,
        customLaunchButtons: ["." + this.chatType],
        mobileNumber: this.phoneNumber
      };

      this._chat = Quiq(newChat);

      // listen for close event on popup close button. This will reset the _chatVisibility across all chat buttons to false.
      $("button[data-test='closeChatButton']")
        .unbind()
        .click(function(e) {
          events.publish("quiqChatClosed");
        });

      // Quiq has difficulty finding something on the initial display.
      // Using the getter lets us wait until that something is found and then
      // set its visibility to true. This is to get around using setTimeout.
      this._chat.getChatVisibility(() => {
        this._toggleChat();
        this._quiqChatInitialized = true;
        events.publish("quiq-chat-initialized", this._chat);
      });

      Array.from(document.querySelectorAll("ns-quiq-chat-button"))
        .filter(
          (item) => item.localName === "ns-quiq-chat-button" && item !== this
        )
        .map((btn) => {
          btn.disabled = true;
          return btn;
        });
    }
  }

  _toggleChat() {
    if (!BrowserDetection.isMobile()) {
      this._chatVisibility = !this._chatVisibility;
      this._chat.setChatVisibility(this._chatVisibility);
    }
  }
}

customElements.define(NsQuiqChatButton.is, NsQuiqChatButton);
